import React                    from 'react';

const MobileIcon = () => {
    return (
        <div className="section-wrapper-header-mobile">
        </div>
    )
}

export default MobileIcon;